module.exports = __webpack_public_path__ + "static/media/April2022Newsletter.7b65a396.pdf";